<template>
    <div class="wrapper--section section-columns" :style="`--bg: ${background}`">
    
        <div class="has-overflow">
            <component :is="title && text ? 'header' : 'div'" class="section-text__content" v-if="title">
                <h2 class="title title--dash" v-html="title" />
                <div class="section__text" v-if="text" v-html="text" />
            </component>

            <ul class="section__columns" :class="{'section__columns--wide': items.length > 3}" :style="`--max: ${items.length}`">
                <li
                    class="section__number-column"
                    v-for="item in items"
                    :key="item.text"
                >
                    <strong ref="numbers" class="number" :data-value="item.title" v-html="item.title" />
                    <span v-html="item.text" />
                </li>
            </ul>
        </div>
        
    </div>
</template>

<script>
import { gsap } from 'gsap'
import { textProps, optionsProps } from './sectionProps'

export default {
    props: {
        items: [Array, Boolean],
        ...textProps,
        ...optionsProps,
    },

    data: () => ({
        observers: [],
    }),

    mounted() {
        this.$nextTick(() => {
            this.$refs.numbers.forEach(this.animateNumber)
        })
    },

    beforeDestroy() {
        this.observers && this.observers.forEach((observer) => observer.disconnect())
    },

    methods: {
        animateNumber(el) {
            const value = el.dataset.value || el.textContent.trim()

            const [, prefix = '', rawNumber, suffix = ''] =
            value.match(/^([^0-9]*)([\d,.]+)(.*)$/) || [];

            const target = parseFloat(rawNumber.replace(/,/g, ''))
            const counter = { value: 0 }
            const formatter = new Intl.NumberFormat('en-CA')

            const observer = new IntersectionObserver(([entry]) => {
                if (!entry.isIntersecting) return;

                gsap.to(counter, {
                    value: target,
                    duration: 1.75,
                    ease: 'expo.out',
                    onUpdate: () => {
                        el.textContent = `${prefix}${formatter.format(Math.round(counter.value))}${suffix}`;
                    },
                    onComplete: () => {
                        el.textContent = value;
                    }
                })

                observer.disconnect();
            }, {
                threshold: 0.4,
            })

                this.observers.push(observer)
                observer.observe(el)
            },
        },
}
</script>

<style lang="scss" scoped>
.section__columns {
    --gap: 1.5rem;
    margin-inline: auto;
    width: 100%;
    max-width: 1366px;

    border-radius: 12px;
    border: 1px dashed var(--purple);
    background: #fff;
}

* ~ .section__columns {
    margin-top: 2rem;
} 

.section__number-column {
    font-size: .825rem;
    color: var(--purple);

    text-align: center;
    padding: var(--gap) 0;

    strong {
        font-size: 4em;
        font-weight: 500;
        display: block;
    }

    & + & {
        border-top: 1px dashed var(--purple);
    }
}

@media (width > 767px) {
    .title {
        text-wrap: balance;
        padding-inline: 5%;
        margin-bottom: 2rem;
    }

    .section__columns {
        display: grid;
    }

    .section__columns--wide {
        --gap: 2rem;
        grid-template-columns: 1fr 1fr;
    }

    .section__number-column {
        font-size: 1rem;
    }
}

@media (1280px > width > 767px) {
    .section__columns--wide .section__number-column {
        font-size: calc(.25rem + 1vw);

        &:nth-child(1),
        &:nth-child(3) {
            border-right: 1px dashed var(--purple);
        }
        &:nth-child(2) {
            border-top: 0;
        }
        &:nth-of-type(3) {
            border-left: 0;
        }
        &:nth-of-type(3),
        &:nth-of-type(4) {
            border-top: 1px dashed var(--purple);
        }
    }
}

@media (width > 1280px) {
    .section__columns {
        --maxi: calc((100% - var(--gap) * var(--max, 3)) / var(--max, 3));
        grid-template-columns: repeat(auto-fit, minmax(var(--maxi), 1fr));
        border-radius: 1rem;
    }
    .section__columns .section__number-column {
        & + .section__number-column {
            border-top: 0;
            border-left: 1px dashed var(--purple);
        }
    }
}
</style>
